import axiosApiClient from "../axios";

const PATH = '/api/company';

export const getAllCompanies = async () => {
    try {
        return await axiosApiClient.get(PATH);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get all companies');
    }
};

export const getCompanyById = async (id) => {
    try {
        return await axiosApiClient.get(`${PATH}/${id}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get company by ID');
    }
};

export const addCompany = async (company) => {
    try {
        console.log('Making API call to add company:', company);
        const response = await axiosApiClient.post(PATH, company);
        console.log('Company creation successful:', response.data);
        return response;
    } catch (err) {
        console.error('Company creation API error:', err);
        console.error('Error response:', err.response?.data);
        console.error('Error status:', err.response?.status);

        if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
            throw new Error('Request timed out. Please check your internet connection and try again.');
        }

        if (err.response?.status === 500) {
            throw new Error('Server error occurred. Please try again later.');
        }
        
        throw new Error(err.response?.data?.message || 'Add Company failed');
    }
};

export const deleteCompany = async (companyId) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${companyId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Delete Company failed');
    }
};

export const updateCompany = async (companyId, company) => {
    try {
        return await axiosApiClient.put(`${PATH}/${companyId}`, company);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Update Company failed');
    }
};

